import { Button, SvgCheck, SvgLink, TextButton } from '@loomhq/lens';
import cn from 'classnames';
import React, { PureComponent } from 'react';

import { SHARE_CTA_ACTION_LINK } from 'constants/events';
import { LOOM_URI } from 'constants/routes';
import * as analytics from 'utilities/analytics';
import * as clipboard from 'utilities/clipboard';

import styles from './styles.module.less';

class CopyLinkSection extends PureComponent {
  static defaultProps = {
    copyText: 'Copy Link',
    video: {},
    withLinkActionDot: false,
    withTopMargin: true,
    className: '',
    copiedText: 'Link Copied!',
    icon: <SvgLink />,
    buttonStyles: '',
    buttonSize: 'medium',
  };

  state = {
    resultText: null,
  };

  trackEvent(type) {
    analytics.track(type, { video_id: this.props.video.id });
  }

  copy = () => {
    if (this.copyTimeout) {
      window.clearTimeout(this.copyTimeout);
      this.copyTimeout = null;
    }

    const didCopy = clipboard.copy(this.inputElement);

    let resultText;

    if (didCopy) {
      resultText = this.props.copiedText;
    } else {
      resultText = 'Error! :-(';
    }

    this.setState({
      resultText,
    });

    this.copyTimeout = window.setTimeout(() => {
      this.setState({
        resultText: null,
      });

      this.copyTimeout = null;

      // stay opaque for a time before fading back out
    }, 2000);

    this.trackEvent(SHARE_CTA_ACTION_LINK);
  };

  render() {
    const { resultText } = this.state;
    const {
      copyText,
      width,
      withTopMargin,
      icon,
      buttonStyles,
      buttonSize,
      textButton,
      completeChecklistItem,
      variant,
    } = this.props;
    const containerStyle = width ? { width } : undefined;

    return (
      <div
        className={cn(
          styles.linkAndButtons,
          resultText ? styles.copyLinkActivated : ''
        )}
        style={containerStyle}
      >
        <input
          className={styles.input}
          ref={me => (this.inputElement = me)}
          readOnly
          value={`${LOOM_URI}${window.location.pathname}`}
        />
        {textButton ? (
          <div className="relative">
            <TextButton
              className={buttonStyles}
              icon={resultText ? <SvgCheck /> : icon}
              onClick={() => {
                this.copy();
                completeChecklistItem();
              }}
              size={buttonSize}
              altText={resultText || copyText}
            >
              {resultText || copyText}
            </TextButton>
          </div>
        ) : (
          <div className={'relative' + (withTopMargin ? ' mt:xsmall' : '')}>
            <Button
              className={buttonStyles}
              icon={resultText ? <SvgCheck /> : icon}
              onClick={() => {
                this.copy();
                completeChecklistItem();
              }}
              hasFullWidth={Boolean(width)}
              variant={variant || 'primary'}
              size={buttonSize}
            >
              {resultText || copyText}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default CopyLinkSection;
